import { FC, useEffect, useState } from 'react';

import { Separator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { formatMoney } from '../../../utils';
import s from './CenterContent.module.scss';
import { COLORS } from './constants';
import { ICenterContentProps } from './interfaces';

export const CenterContent: FC<ICenterContentProps> = ({ data }) => {
  const summary = data.reduce((sum, item) => sum + item.value, 0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={cn(s.container, isVisible && s.visible)}>
      <ul className={s.list}>
        {data.map((item, index) => (
          <li key={item.name} className={cn(s.item)}>
            <div className={s.top}>
              <span
                className={s.value}
                style={{ color: COLORS[index % COLORS.length] }}
              >
                {formatMoney(item.value)}
              </span>
              <Separator className={s.separator} />
              <span className={s.percent}>
                {((item.value / summary) * 100) % 1 === 0
                  ? (item.value / summary) * 100
                  : ((item.value / summary) * 100).toFixed(1)}
                %
              </span>
            </div>
            <span className={s.title}>{item.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
